// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2AeSQ","footer":"Form_footer__1tSn4"};